import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'new-risk-profiling',
    path: '/new-risk-profiling',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'new-risk-profiling',
      breadcrumb: {
        label: 'core.menu.modules.risk-exposure',
        route: 'new-risk-profiling',
      },
    },
    children: [
      {
        name: 'new-risk-profiling-home',
        path: '/new-risk-profiling',
        meta: {
          allowedRoles: [...allowed.new_risk_profiling.roles],
          breadcrumb: {
            label: 'core.menu.modules.new-risk-profiling-home',
            route: 'new-risk-profiling-home',
          },
        },
        component: () =>
          import(
            '@/modules/new-risk-profiling/containers/populate-risk-register.container.vue'
          ),
      },
      {
        name: 'new-risk-profiling-overview',
        path: '/new-risk-profiling/risk-overview',
        meta: {
          requiresAuth: true,
          layout: 'home',
          module: 'new-risk-profiling',
          allowedRoles: [...allowed.new_risk_profiling.roles],
          breadcrumb: {
            label: 'new-risk-profiling.risk-overview.moduleTitle',
            route: 'new-risk-profiling-overview',
          },
        },
        component: () =>
          import(
            '@/modules/new-risk-profiling/containers/risk-overview/risk-overview.container.vue'
          ),
      },
      {
        name: 'new-risk-profiling-risk-details',
        path: '/new-risk-profiling/risk-overview/:riskId',
        meta: {
          requiresAuth: true,
          layout: 'home',
          module: 'new-risk-profiling',
          allowedRoles: [...allowed.new_risk_profiling.roles],
          breadcrumb: {
            label: 'new-risk-profiling.risk-details.moduleTitle',
            route: 'new-risk-profiling-risk-details',
          },
        },
        component: () =>
          import(
            '@/modules/new-risk-profiling/containers/risk-details/risk-details.container.vue'
          ),
      },
      {
        name: 'new-risk-profiling-critical-control-verification',
        path: '/new-risk-profiling/critical-control-verification-dashboard',
        meta: {
          requiresAuth: true,
          layout: 'home',
          module: 'new-risk-profiling',
          allowedRoles: [
            ...allowed.new_risk_profiling.dashBoardViewer,
            ...allowed.new_risk_profiling.checklistTaker,
            ...allowed.new_risk_profiling.checklistScheduleManager,
            ...allowed.new_risk_profiling.checklistAdHocManager,
          ],
          breadcrumb: {
            label: 'core.menu.modules.new-risk-profiling-critical-control-verification',
            route: 'new-risk-profiling-critical-control-verification',
          },
        },
        component: () =>
          import(
            '@/modules/new-risk-profiling/containers/critical-control-verification/critical-control-verification.container.vue'
          ),
      },
      {
        name: 'new-risk-profiling-critical-control-verification-run',
        path: '/new-risk-profiling/critical-control-verification-dashboard/runs/:runId',
        meta: {
          requiresAuth: true,
          layout: 'home',
          module: 'new-risk-profiling',
          allowedRoles: [
            ...allowed.new_risk_profiling.checklistTaker,
            ...allowed.new_risk_profiling.checklistScheduleManager,
            ...allowed.new_risk_profiling.checklistAdHocManager,
          ],
          breadcrumb: {
            label: 'core.menu.modules.new-risk-profiling-critical-control-verification',
            route: 'new-risk-profiling-critical-control-verification-run',
          },
        },
        component: () =>
          import(
            '@/modules/new-risk-profiling/containers/critical-control-verification/critical-control-verification.container.vue'
          ),
      },
    ],
  },
]

export default index
